<template>
    <div>
        <card-header title="Registration Questions" icon="fa-question-circle"></card-header>

        <card-toolbar>
            <button @click="$openCard('conf-new-question', {confId: conference.id}, card)"><i class="far fa-plus"></i>New Question</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <draggable v-model="conference.questions" handle=".handle" @change="updateOrder">
                    <transition-group>
                        <conf-question-tile
                            :card="card"
                            :question="question"
                            v-for="question in conference.questions"
                            :active="(child && child.definition.component === 'conf-edit-question' && question.id === parseInt(child.props.questionId))"
                            @click="$openCard('conf-edit-question', {confId: question.conference_id, questionId: question.id}, card)"
                            :key="question.id"
                            class="t-card-list-item"
                        />
                    </transition-group>
                </draggable>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import draggable from 'vuedraggable';

    import {client as http} from "@/http_client";
    import ConfQuestionTile from "../../../components/ConfQuestionTile";

    export default {
        components: {ConfQuestionTile, CardToolbar, CardList, CardHeader, CardBody, draggable},
        props: ['card', 'props', 'child'],
        data() {
            return {
                conference: {
                    questions: []
                }
            }
        },

        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            updateOrder: function() {
                let order = [];
                for (let i = 0; i < this.conference.questions.length; i++) {
                    order.push(this.conference.questions[i].id)
                }
                http.post('conferences/' + this.props.confId + '/questions/order', {order}).then(response => {

                }).catch(err => {

                });
            },
            reload: function() {
                this.loadConference(true);
            }
        },
        mounted() {
            this.loadConference();
        }
    }
</script>

<style>

</style>
